<div *ngIf="lang =='ar'" dir="rtl" style="padding: 25px; background-color: #ffffff">
  <div class="header">
    <div class="logo">
      <div class="service-logo">
        <img
          src="./assets/images/newLogo.png"
        />
      </div>
      <div class="company-logo">
        <img
          src="./assets/images/digitalLogo.png"
          height="100px"
        />
      </div>
    </div>

    <div class="heading">
      <h1>الشروط والأحكام تطبيق خدمة في اي بي.</h1>
      <span>Version number: 0.1</span> <br/>
      <span>Date: 11-1-2021</span>
    </div>

  </div>
  <div class="content-menu">
    <ul>
      <h2>* قائمة المحتويات</h2>
      <li>بيان الملكية الفكرية.</li>
      <li>الشروط والأحكام.</li>
      <li>الحساب والمستخدم المسجل لدي التطبيق.</li>
      <li>عملية الطلب.</li>
      <li>عملية الدفع.</li>
      <li>المسؤولية والتعويض.</li>
      <li>الإسترجاع.</li>
      <li>خدمة التوصيل.</li>
      <li>أحكام متنوعة.</li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* أولا : بيان الملكية الفكرية.</h3>
      <li>
        1-1 "الموقع" و "التطبيق" يملكه ويديره شركة ديجيتال يونيفرس لتكنولوجيا
        المعلومات ذ. م. م. والمشار إليها بلفظ digital universe باللغة الإنجليزية
        و الموقع التالي 5dma.vip”" مملوك لها وأن التطبيق الإلكتروني والموقع
        الإلكتروني مسجلين لدي مكتب حماية حقوق الملكية والفكرية بهيئة تنمية صناعة
        تكنولوجيا المعلومات كما انهما مسجلان لدي المنظمة العالمية للملكية
        الفكرية في عدة دول.
      </li>
      <li>
        2-1 بإستخدامك لموقعنا وتطبيقنا فإنك تقر وتوافق على أن جميع حقوق النشر
        والعلامات التجارية وسائر حقوق الملكية الفكرية في جميع المواد و / أو
        المحتويات المتاحة في الموقع والتطبيق هى ملك دائم لنا ويسمح لك بإستخدام
        هذه المواد و / أو المحتوى فقط على النحو المصرح به من قبلنا.
      </li>
      <li>
        3-1 جميع أسماء المنتجات والأسماء التجارية وأسماء الخدمات و الشعارات أو
        العلامات التصويرية المميزة بشكلها أو كتابتها ، أو غير ذلك عن النص المحيط
        (على سبيل المثال ، استخدام الأحرف المميزة) ، (بالجمع "العلامات") هي
        علامات تجارية مملوكة و مرخصة لشركة ديجيتال يونيفرس ، ما لم يذكر خلاف
        ذلك. جميع العلامات الموجودة علي التطبيق والموقع محمية وفق قوانين جمهورية
        مصر العربية ودول أخرى.و من غير المصرح إستخدام أي من هذه العلامات بدون
        موافقة كتابية مسبقة من شركة ديجيتال يونيفرس.
      </li>
      <li>
        4-1 بإستخدامك لتطبيقنا فإنك تقر وتوافق على أن جميع المواد والمجتوي متاحة
        فقط للإستخدام الشخصي غير التجاري ،. أنت تقر أيضا بأنه يمنع منعا باتا أي
        استخدام آخر للمواد والمحتوى على التطبيق وأنك توافق على عدم مساعدة أو
        تسهيل أي طرف ثالث نسخ أو إعادة إنتاج أو نقل أو نشر أو عرض أو توزيع أو
        استغلال بشكل تجاري أو إنشاء أعمال مشتقة من هذه المواد.
      </li>
      <li>
        5-1 شركة ديجيتال يونيفرس تمتلك الحق ولكن ليست ملزمة بالقيام برصد وتعديل
        أو إزالة أي نشاط أو محتوى المستخدم ، ولا تتحمل أية مسؤولية ، ولا تتحمل
        أية توابع قانونية عن أي محتوى للمستخدم تم نشره سواء كان لك أو محتوى تم
        نشره من قبل أي طرف ثالث.
      </li>
      <li>
        6-1 الغرض من التطبيق السماح للمستخدمين طلب السلع والخدمات من العديد من
        المتاجر كما أن الموقع الإلكتروني يسمح للمتاجر من إدارة السلع والخدمات
        التي يقدمونها للمستخدمين بأنفسهم دون تدخل مباشر من شركة ديجيتال يونيفرس
        ولكننا نعمل علي ضمان جودة الخدمات المقدمة من أصحاب المتاجر .
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* ثانياً الشروط والأحكام:</h3>
      <li>
        1-2 كمستخدم لهذا التطبيق (المشار إليه بلفظ "أنت / الخاص بك") ، فإنك تقر
        بأن استخدامك لهذا الموقع لأي سبب من الأسباب ، بما في ذلك إجراء التعاملات
        ("استخدام / باستخدام") يخضع للشروط والأحكام المذكورة أدناه ، والتي تشمل
        بدون تحديد ، روابط فعالة لأقسام أخرى مرتبطة مثل سياسة الخصوصية ، التوصيل
        ، الاسترجاع و ما إلى ذلك (يتم الإشارة إليها بالجمع بلفظ "الشروط").
      </li>
      <li>
        2-2 أنظر التاريخ يحق لنا تغيير هذه البنود والشروط في أي وقت. ويتم اعتبار
        أي من هذه التغييرات سارية المفعول في اليوم الذي يتم فيه النشر. لذا لابد
        من مراجعة الشروط والأحكام بشكل دوري قبل إستخدام تطبيق خدمة. وبإستخدامك
        للموقع فإنك توافق علي كافة الشروط والأحكام المذكورة أدناه وفي حال عدم
        موافقتك علي كل هذه الشروط أو جزء منها فلابد من التوقف عن إستخدام
        التطبيق.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* ثالثاً الحساب والمستخدم المسجل لدي التطبيق:</h3>
      <li>
        1-3 يجب عليك التسجيل وإنشاء "حساب" لدي التطبيق. من أجل الوصول الي
        الخدمات ، مع العلم أن اي "حساب" تقوم بتسجيله هو حساب رسمي وشخصي لك وغير
        قابل للإستخدام عن طريق طرف ثاالث.
      </li>
      <li>
        2-3 بالتسجيل واستخدام التطبيق ، فإنك تضمن أن المعلومات التي قدمتها في
        سياق عملية التسجيل صحيحة ودقيقة وأنك تتعهد بالتأكد من أن يتم تحديث هذه
        المعلومات بشكل يبقيها صحيحة. و أنك مسئول عن الحفاظ على سرية الحساب الخاص
        بك ، وتوافق على قبول المسؤولية عن جميع الأنشطة التي تحدث ضمن حسابك. و في
        حال كان لديك أي مخاوف بشأن حسابك ، أو إن علمت بأي سوء استخدام لحسابك
        فإنه يتوجب عليك إعلامنا بذلك على الفور (انظر قسم الاتصال بنا لمزيد من
        المعلومات وبيانات الاتصال الكاملة).
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* رابعاً عملية الطلب :</h3>
      <li>
        1-4 بصفتك مستخدم مسجل، يمكنك طلب وشراء المنتجات. إذا كان يتوجب دفع مبلغ
        على منتج قد قمت بطلبه ، فعليك دفع المبلغ الكامل لهذا المنتج كما هو موضح
        أثناء عملية الطلب ، بما في ذلك تكاليف الشحن والرسوم الأخرى التي يمكن أن
        تطبق على هذا الطلب. يمكنك الإطلاع على شروط الدفع و التوصيل أدناه .
      </li>
      <li>
        2-4 التأكيد" هي مرحلة تحدد التفاصيل النهائية لطلبك. بعد هذا، سوف نرسل لك
        بريدا الكترونياً بتأكيد العملية و به تفصيل للمنتجات التي قمت بطلبها.
        يرجى ملاحظة أن هذا البريد الإلكتروني ليس من أجل تأكيد الطلب أو قبول
        الطلب.
      </li>
      <li>
        3-4 بعد قبول طلبك، يتم إتمام العقد بينك وبين مزود الخدمة بعد قبول الطلب
        بتوصيل ما قمت بطلبه إليك، إذا دفعت ثمن شراء المنتجات بإستخدام بطاقتك
        (غير متوفرة الأن) أو عند توصيل المنتجات إلى عنوانك وشريطة استلام مزود
        الخدمة لثمن الشراء بالكامل، ما لم نقم بإعلامك بأن طلبك قد تم رفضه أو ما
        لم تقم بإلغاء الطلب(يرجى الرجوع إلى قسم الاسترجاع أدناه).
      </li>
      <li>
        4-4 نحن نحتفظ بطلبك ويتم عرضه علي حسابك لمراجعتها في المستقبل في التطبيق
        ولكن يحق لنا التخلص من الطلبات القديمة المغلقة اذا تطلب الأمر لذلك
        لأسباب خارجة عن إرادتنا لذلك ننصح بطباعة الطلبات والاحتفاظ بها للرجوع
        اليها أذا أردت ذلك.
      </li>
      <li>
        5-4 قد تكون هناك أخطاء في الأسعار التي تظهر على تطبيق خدمة في أي بي أو
        أثناء عملية إجراء الطلب من وقت لآخر. قد يكون هناك أيضا أخطاء في الإرسال
        قد تؤدي إلى انقطاع لعملية الشراء. سوف تبذل شركة ديجيتال يونيفرس أقصى
        جهدها لمحاولة حل أية مشاكل قد تنشأ نتيجة لمثل هذه الأخطاء.ويأتى دورك
        بالموافقة على التعاون مع الشركة في حل مثل هذه الأمور، وأنت توافق على أن
        تكون للشركة الحرية الكاملة للتصرف ولتحديد القرار المناسب في مثل هذه
        الحالات.
      </li>
      <li>
        6-4 تقوم أطراف أخرى غير شركة ديجيتال يونيفرس بإعلان وتقديم الخدمات (يشار
        إليهم بمزودي الخدمات) أو بيع منتجاتها من خلال تطبيقنا و سيتم تقييد هذه
        المشتريات من الأطراف الأخرى وقت إجراء الطلب وسوف تطبق عليها هذه الشروط
        فضلا عن أي شروط وأحكام أخرى قد يمليها هذا الطرف الثالث الذي قام بعملية
        البيع. بالرغم من أن ديجيتال يونيفرس تبذل كافة الطرق المتاحة لتضمن جودة
        الخدمات المقدمة من مزودي الخدمات إلا أننا لا نضمن ما تقدمه أي من هذه
        المتاجر أو الأفراد من عروض ومنتجات ، و قيامك بالشراء من أي من هؤلاء
        الأطراف أو الأفراد هو مسؤوليتك الشخصية و عليك تحمل تكلفته.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* خامساً عملية الدفع :</h3>
      <li>
        5-1 يتم الدفع عن طريق أحد الطرق المتاحه في الطلب ويتم تحديد طريقة الدفع
        عن طريق المستخدم اثناء إنشاء الطلب.
      </li>
      <li>5-2 طرق الدفع المتاحة الأن هي (الدفع عند الإستلام).</li>
      <li>
        5-3 السعر الذي تدفعه عند إستلام طلبك هو السعر المعروض علي التطبيق. في
        الوقت الذي تم إستلام طلبك به. فيما عدا بعض الإستثناءات.
      </li>
      <li>
        5-4 جميع الأسعار المذكورة علي التطبيق هي مسؤولية مزود الخدمة أو المتجر
        وشركة ديجيتال يونيفرس غير مسؤولة عنها .
      </li>
      <li>
        5-5 إذا لم يستطيع مزود الخدمة من التواصل معك إذا تطلب الأمر يحق له أن
        يقوم بإلغاء الطلب.
      </li>
      <li>
        5-6 أخطار الخسارة أو الضرر أو ملكية المنتجات. تنتقل لك بمجرد تسلمك
        المنتجات ودفع كامل ثمنها في العنوان المذكور بالطلب.
      </li>
      <li>
        5-7 جميع الأسعار المذكورة هي بالجنيه المصري وتشمل الضرائب وسعر التوصيل
        إن وجدت.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>سادساً المسؤولية والتعويض :</h3>
      <li>
        1-6 ديجيتال يونيفرس لا تضمن بأن التطبيق أو أي من الخدمات أو المنتجات
        المتاحة من خلاله سيبقى دون انقطاع أو خال من الأخطاء. قد يكون هناك تأخير،
        أو حذف أو انقطاع ، و / أو عدم الدقة في المواد أو الخدمات المتاحة من خلال
        التطبيق.
      </li>
      <li>
        2-6 على الرغم من أن ديجيتال يونيفرس تقوم بخطوات معقولة لمنع دخول
        الفيروسات و غيرها من الرموز الالكترونية الأخرى على التطبيق ،فإن ديجيتال
        يونيفرس لا تصرح أو تضمن بأن الخدمات أو المنتجات أو المواد ، خالية من هذه
        العوامل المدمرة. وأننا غير مسؤولين عن اي أضرار ناشئة بشكل مباشر او غير
        مباشر بسبب هذه العوامل..
      </li>
      <li>
        3-6 لا يجوز في أي حال من الأحوال اعتبار ديجيتال يونيفرس مسئولا من قبلك
        أو أي طرف ثالث عن أي خسائر مباشرة، غير مباشرة، خاصة أو تبعية، أو أضرار
        من أي نوع ( تشمل على سبيل المثال ، فقدان الأرباح أو انقطاع الأعمال ،
        وفقدان برامج أو غيرها من البيانات على نظام المعلومات الخاص بك) ، حتى لو
        تم إبلاغ ديجيتال يونيفرس ..
      </li>
      <li>
        4-6 على الرغم من أي شيء يتعارض مع هذا فإن إجمالي المسئولية التي تقع على
        ديجيتال يونيفرس (سواء في المسؤولية التقصيرية أو التعاقدية أو غير ذلك) عن
        أي من الخسائر أو الأضرار التي قد تقع عليك من جراء استخدامك للموقع ،
        تقتصر على مبلغ يعادل المبلغ المدفوع أو المستحق الدفع من قبلك للمنتج أو
        المنتجات في سياق حادث واحد أو سلسلة من الحوادث التي تعزى إلى نفس السبب.
      </li>
      <li>
        5-6 سوف نتخذ جميع الاحتياطات المعقولة للحفاظ على تفاصيل طلبك والدفع
        الآمن ، ولكن ما لم نكن على إهمال ، فلا يمكن أن نكون مسئولين عن أي خسائر
        نتيجة الدخول غير المصرح به للمعلومات التي قدمتها. إذا ، فأنت مسئول عن
        الحفاظ على سرية حسابك و كلمة المرور الخاصة بك.
      </li>
      <li>
        6-6 شركة ديجيتال يونيفرس تحتفظ بالحق في رفض الخدمة ، إنهاء حسابات أو
        إزالة أوصياغة المحتوى ، أو إلغاء الطلبات حسب تقديرها المطلق.
      </li>
      <li>
        7-6 إنك باستعمالك للتطبيق توافق على، بحسب ما يسمح به القانون، أن تعوِّض
        ديجيتال يونيفرس ، ومديريها، ومسئوليها، وموظفيها، والشركات المنتسبة لها،
        ووكلائها، ومقاوليها، وموكليها، ومُرخِّصيها وتحميها من الضرر فيما يتعلق
        بأية مطالبات ناشئة عن إخلالك بهذه الشروط أو استعمالك التطبيق او المنتجات
        أو اخلالك بالقانون المطبق في المكان الذي تدخل منه الى التطبيق ، أو أي
        إجراء تتخذه شركة ديجيتال يونيفرس كجزء من تحقيقها فيما يشتبه في أنه
        مخالفة لهذه الاتفاقية أو كنتيجة استنتاجها أو قرارها بأن مخالفة ما حدثت
        لهذه الاتفاقية.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* سابعاً الإسترجاع :</h3>
      <li>
        1-7 نحن ملتزمون بالتعاقد مع مزودي خدمات ذات جودة عالية ونحن نتمنى أن
        تستمتعوا بها. ومع ذلك فإننا نعرف أيضا أنه لسبب أو لآخر ، قد يكون هناك
        وقت قد تحتاج فيه إلى تبديل أو إعادة شيء قمت بشرائه.
      </li>
      <li>
        2-7 الرجاء التأكد من فحص المنتج الخاص بك بعناية عند التوصيل و ذلك قبل
        الاستخدام أو قبل أن تقوم بالتركيب.
      </li>
      <li>
        3-7 نوصي أيضا أن تحتفظ بإيصال التوصيل ونسخة من الطلب الخاص بك، يمكنك
        الوصول إليهم من ملف التعريف الخاص بك في التطبيق ، كدليل على الشراء في
        حال وجود أي استفسار ما بعد البيع. ان المنتجات التي يتم شراؤها، يمكن
        إعادتها أو تبديلها حسب سياسة مزود الخدمة الخاصة.
      </li>
      <li>
        4-7 جميع الأحجام و القياسات للمنتجات تقريبية ولكن نحث مزودي الخدمات من
        التأكد من دقتها على قدر الإمكان. وفي بعض الأحيان يمكن أن تكون مواصفات
        المنتج من الشركة المصنعة قد تغيرت أو قد تكون هناك مشكلة في توفر بعض
        المنتجات، في هذه الحالة يمكن توفير البديل من نفس النوعية أو أفضل بنفس
        السعر. إذا كنت غير راض عن الاستبدال أو البديل، يمكنك إرجاع هذه المنتجات
        وفقا للشروط المذكورة من مزود الخدمة.
      </li>
      <li>
        5-7 اذا كانت المنتجات التي سيتم إرجاعها أو استبدالها بها عيب، غير مطابقة
        للمواصفات المعمول بها في جمهورية مصر العربية ، أو إذا كان العيب القائم
        لا يمكن إصلاحه دون أن يؤثر ذلك على جودة هذه المنتجات. إذا كانت جودة هذه
        المنتجات لن تكون معرضة للخطر، لمزود الخدمة الحق في رفض استبدال أو
        استرجاع هذه المنتجات.
      </li>
      <li>
        6-7 يمكن استبدال المنتجات أو إعادتها اذا كانت غير أصلية أو مزورة. و يتم
        التواصل معنا في حالة رفض إرجاع الطلب من قبل مزود الخدمة.
      </li>
      <li>
        7-7 لمزود الخدمة الحق في عدم استبدال أو إسترجاع منتجات محددة مثل الساعات
        والمواد الغذائية و الملابس الداخلية، وما إلى ذلك من منتجات تتلامس مع
        الجلد إلا في حالة عيوب التصنيع أو عدم الامتثال مع المواصفات أو المعايير
        المنصوص عليها أو إذا كان هذا المنتج المباع مختلف عن المنتج االذي دفعت
        قيمته. في مثل هذه الحالات، قد يقوم مزود الخدمة بتوفير المنتجات البديلة
        إلا لو اتفق على خلاف ذلك معك.ويتم رفع شكوي لديجيتال يونيفرس في حال عدم
        تطبيق الشروط من قبل مزود الخدمة.
      </li>
      <li>
        8-7 يمكنك استبدال المنتجات أو إعادتها إذا كانت موافقة للشروط أعلاه
      </li>
      <li>
        9-7 يمكنك الإتصال علي مزود الخدمة مباشرة لتحديد موعد إسترجاع المنتج
      </li>
      <li>
        10-7 يرجى العلم أن عملية استرداد المبلغ ستتم بنفس طريقة الدفع التي
        استعملتها اثناء الشراء او لديك الخيار بقبول كوبونات الهدايا او استبدال
        المنتج بنفس المبلغ الذي دفعته حسب إتفاقك مع مزود الخدمة.
      </li>
    </ul>
  </div>

  <div class="menu-item-details">
    <ul>
      <h3>* ثامناً خدمة التوصيل :</h3>
      <li>
        1-8 يحمل المستخدم مسئولية توفير أرقام الهاتف الصحيحة (الأرضية والمحمولة)
        وعنوان التسليم الصحيح.
      </li>
      <li>
        2-8 إذا كان الطلب يحتاج توصيل وتركيب تحدد مصاريف التوصيل والتركيب من
        خلال مزود الخدمة.
      </li>
      <li>
        3-8 في حال عدم تواجد العميل، سيتم تسليم الأغراض لأي شخص آخر متواجد في
        العنوان التابع للعميل يستلم الأغراض ويوقع على طلب التوصيل، ويُعد بذلك
        العميل قد استلم المنتج.
      </li>
      <li>
        4-8 سوف تحث شركة ديجيتال يونيفرس مزودي الخدمات لبذل قصارى جهدهم للتسليم
        في الوقت المحدد، ولا تتحمل أي مسؤولية تجاه أي تأخير في التسليم من مزود
        الخدمة.
      </li>
      <li>
        5-8 رسوم التوصيل غير قابلة للاسترجاع من مزود الخدمة في حالة وضع معلومات
        توصيل خاطئة أو في حال عدم امكانية الوصول للعميل عبر رقم الهاتف.
      </li>
      <li>
        6-8 الرجاء التأكد من إعطاء عنوان التوصيل الصحيح عند طباعة الفاتورة حيث
        أن هذا سيمكن مزود الخدمة من التوصيل السريع وفي الوقت المناسب لك و لغيرك
        من العملاء.
      </li>
      <li>
        7-8 الرجاء توفير المعلومات التالية:
        <ul>
          <li>المحافظة :</li>
          <li>المركز :</li>
          <li>المدينة :</li>
          <li>رقم القطعة :</li>
          <li>رقم الشارع :</li>
          <li>رقم المبني :</li>
          <li>اسم المستلم :</li>
          <li>رقم هاتف المستلم :</li>
        </ul>
      </li>
      <li>
        8-8 إذا كان هناك تغيير في عنوان التوصيل بعد إصدار الفاتورة، يمكنك
        التواصل مع مزود الخدمة ومراجعته وتصحيح العنوان.
      </li>
      <li>9-8 نود أن تكون على علم بحالة ووقت توصيل طلبيتك من مزود الخدمة.</li>
    </ul>
  </div>

  <div class="menu-item-details">
    <ul>
      <h3>* تاسعاً أحكام متنوعة :</h3>
      <li>
        1-9يخضع العقد بينك و بين ديجيتال يونيفرس لقوانين جمهورية مصر العربية،
        دون النظر في ما يتعلق بقواعد تنازع القوانين وأي نزاع بينك وبين ديجيتال
        يونيفرس يتم النظر فيه حصرا في محاكم جمهورية مصر العربية .
      </li>
      <li>
        2-9 لا يتحمل ديجيتال يونيفرس أية مسؤولية عن أي تأخير أو فشل لتسليم
        المنتجات أو خلاف ذلك أداء أي التزام كما هو محدد في هذه الشروط إذا ما كان
        السبب كليا أو جزئيا ناتجا عن الأحداث القاهرة و / أو بسبب قوة قاهرة ،
        سواء بشكل مباشر أو غير مباشر ، بسبب ظروف خارجة عن سيطرتها المعقولة.
        لتجنب أي شك، فإن احداث القوة القاهرة تعني وتشمل بدون تحديد أحداث الحرب،
        أعمال الشغب، الحرب الأهلية، التمرد، الزلازل، الأعاصير والفيضانات أو
        غيرها من الكوارث الطبيعية المادية و / أو أعمال الطبيعة .
      </li>
      <li>
        3-9 أي روابط أو إشارات إلى مواقع إنترنت أخرى ("الروابط التشعبية-
        هايبرلينكس") الواردة في 5dma.vip بواسطة ديجيتال يونيفرس هي لمجرد الراحة
        لمستخدمي 5dma.vip ، وديجيتال يونيفرس ليست مسئولة عن محتوى أو تشغيل أي من
        هذه المواقع المرتبطة بالإنترنت . ولا ينبغي بأي حال من الأحوال اعتبار أية
        روابط تشعبية لمثل هذه المواقع على شبكة الإنترنت كتعزيز من قبل شركة
        ديجيتال يونيفرس أو دعاية أو تأكيد فيما يتعلق بالمحتوى ، والتصريحات ، والدقة ،
        والمنتجات أو الخدمات أو المحتوى. استخدام تلك الروابط التشعبية
        (هايبرلينكس) يتم على مسؤوليتك وعلى تكلفتك.
      </li>
      <li>
        4-9 تحتفظ ديجيتال يونيفرس بحقها في نقل وتعيين أو التعاقد من الباطن لكل
        أو جزء من أي من حقوقها أو التزاماتها بموجب هذه الشروط أو أي عقد آخر ذي
        صلة ، إلى أي طرف ثالث.
      </li>
      <li>
        5-9 إذا اعتبر جزء من هذه الشروط من قبل أي سلطة مختصة غير صالحة أو غير
        قابلة للتطبيق كليا أو جزئيا ، فإن ذلك لا يؤثر على صحة أو قابلية تنفيذ
        الشروط الأخرى.
      </li>
      <li>
        6-9 هذه الشروط لا تخلق أو تمنح أية حقوق أو منافع قابلة للتنفيذ من قبل أي
        شخص ليس طرفا فيها.
      </li>
      <li>
        7-9 أي تأخير أو فشل من قبل ديجيتال يونيفرس لممارسة أي سلطات ، وحقوق ، أو
        تعويضات بموجب هذه الشروط لا يعد بمثابة تنازل لديجيتال يونيفرس عنها , و
        أية ممارسة لجزء من هذه الحقوق و القوى ، لا يحول دون تحصيل حقوق أو
        تعويضات أخرى أو ممارسة المزيد منها. ليصبح أي تنازل فعالا يجب أن يكون
        كتابيا وموقع من قبل ممثل مفوض من ديجيتال يونيفرس.
      </li>
      <li>
        8-9 إن هذه الشروط بما في ذلك الوثائق أو المصادر الأخرى المشار إليها في
        هذه الشروط تسمو فوق كل التأكيدات السابقة ، والتفاهمات والاتفاقيات بينك
        وبين ديجيتال يونيفرس المتصلة باستخدام 5dma.vip او التطبيق (بما في ذلك
        استخدام الخدمات و / أو طلب المنتجات) ويحدد مجمل الاتفاق والتفاهم بينك
        وبين ديجيتال يونيفرس بشأن الاستخدام الخاص للتطبيق و 5dma.vip.
      </li>

      <li>
        9-9 عند زيارة 5dma.vip أو إرسال رسائل البريد الإلكتروني لنا ، فإنك تقوم
        بالتواصل معنا إلكترونيا. و بهذا فأنت توافق على تلقي الاتصالات منا
        الكترونيا. وسوف نتواصل معك عن طريق البريد الالكتروني أو الهاتف.
      </li>
      <li>
        10-9 أنت توافق على أن كافة الاتفاقات والإشعارات والكشوف ، وغيرها من
        الاتصالات التي نقدمها لكم إلكترونيا تلبي أي مطلب قانوني ينص على أن تكون
        سبل التواصل مكتوبة.
      </li>
    </ul>
  </div>
  <div
    class="menu-item-details"
    style="color: gray; font-weight: bold; margin-top: 100px"
  >
    <ul>
      <li>
        شركة ديجيتال يونيفرس لتكنولوجيا المعلومات ذ. م. م. ميت غمر – الدقهلية -
        مصر
      </li>
      <li>جمهورية مصر العربية</li>
      <li>مسجلة في جمهورية مصر العربية – رقم 9226</li>
      <li>البريد الإلكتروني : Info&#64;du-apps.com</li>
      <li>الموقع الإلكتروني : www.du-apps.com</li>
      <li>
        نوصي بطباعة نسخة من هذه الشروط لتكون مرجعا في المستقبل. إذا كان لديك أي
        أسئلة بخصوص هذا الموقع 5dma.vipاو التطبيق أرجع إلى قسم الإتصال بنا لمزيد
        من المعلومات وتفاصيل الاتصال الكاملة.
      </li>
    </ul>
  </div>
</div>
<div *ngIf="lang =='en'" dir="ltr" style="padding: 25px; background-color: #ffffff">
  <div class="header">
    <div class="logo">
      <div class="service-logo">
        <img
          src="./assets/images/newLogo.png"
        />
      </div>
      <div class="company-logo">
        <img
          src="./assets/images/digitalLogo.png"
          height="100px"
        />
      </div>
    </div>

    <div class="heading">
      <h1>Terms and Conditions of use of the 5dma VIP</h1>
      <span>Version number: 0.1</span> <br/>
      <span>Date: 11-1-2021</span>
    </div>
  </div>
  <div class="content-menu">
    <ul>
      <h2>* Table of Contents</h2>
      <li>Intellectual Property Statement.</li>
      <li>Terms and conditions.</li>
      <li>Account and registered user of the app.</li>
      <li>Ordering process.</li>
      <li>Payment process.</li>
      <li>Liability and compensation.</li>
      <li>Recovery.</li>
      <li>Delivery service.</li>
      <li>Miscellaneous provisions.</li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* 1: Intellectual Property Statement.</h3>
      <li>
        1.1 The “Site” and “Application” is owned and operated by Digital Universe Technologies, Inc.
        Information Technology LLC. L.L.C. L.L.C. referred to as Digital universe in English
        and the following website 5dma.vip is owned by it and that the Application and the Website
        are registered with the Office for the Protection of Intellectual Property Rights at the Information Technology Industry Development Agency
        They are also registered with the World Intellectual Property Organization
        in several countries.
      </li>
      <li>
        2.1 By using our website and application, you acknowledge and agree that all copyrights
        trademarks and other intellectual property rights in all materials and/or
        content available on the Website and Application is our permanent property and you are authorized to use
        such materials and/or content only as authorized by us.
      </li>
      <li>
        3.1 All product names, trade names, service names, logos or
        pictorial marks distinguished by their shape or writing, or otherwise from surrounding text
        (e.g., use of distinctive characters), (collectively “Marks”) are
        trademarks owned by and licensed to Digital Universe, unless otherwise noted
        otherwise. All Marks on the Application and the Site are protected by the laws of
        Egypt and other countries. You are not authorized to use any of these Marks without
        Digital Universe's prior written consent.
      </li>
      <li>
        4.1 By using our Application, you acknowledge and agree that all materials and content are available
        solely for your personal, non-commercial use. You also acknowledge that any
        other use of the materials and content on the App and you agree not to assist or
        facilitate any third party to copy, reproduce, reproduce, transmit, publish, display, distribute, commercially
        commercially exploit or create derivative works from such materials.
      </li>
      <li>
        5.1 Digital Universe has the right but not the obligation to monitor, edit
        or remove any User Content or activity, and assumes no responsibility, liability, or
        any legal consequences for any User Content posted whether it is yours or content posted by
        posted by any third party.
      </li>
      <li>
        6.1 The purpose of the app is to allow users to order goods and services from multiple
        stores and the website allows stores to manage the goods and services
        that they provide to users themselves without the direct intervention of Digital Universe.
        However, we work to ensure the quality of the services provided by the store owners.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* Terms and Conditions:</h3>
      <li>
        1.2 As a user of this application (referred to as “you/your”), you acknowledge
        that your use of this website for any reason whatsoever, including making transactions
        (“Use”) is subject to the terms and conditions listed below, which include
        without limitation, effective links to other linked sections such as Privacy Policy, Delivery
        Returns, etc. (collectively, the “Terms”).
      </li>
      <li>
        2.2 See Date We have the right to change these terms and conditions at any time. And any
        any such changes are effective on the day they are posted. You should
        review the Terms and Conditions periodically before using the Service. By using
        of the Website, you agree to all of the terms and conditions listed below, and if you do not agree to all or part of these terms and conditions
        If you do not agree to all or part of these terms, you must discontinue using
        Application.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* Third, the account and user registered with the app:</h3>
      <li>
        1-3 You must register and create an “account” with the app. In order to access the
        Services, any “Account” you register is your official and personal account and is not
        usable by a third party.
      </li>
      <li>
        2.3 By registering and using the Application, you warrant that the information you have provided in the
        in the course of the registration process is true and accurate and you undertake to ensure that such information is updated
        is kept up to date. You are responsible for maintaining the confidentiality of your account
        You agree to accept responsibility for all activities that occur under your account. If you
        if you have any concerns about your account, or if you become aware of any misuse of your account
        you must notify us immediately (see the Contact Us section for more
        information and full contact details).
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* 4 Ordering process:</h3>
      <li>
        1.4 As a registered user, you can order and purchase products. If a payment is required
        for a Product you have ordered, you must pay the full amount for that Product as shown
        during the ordering process, including shipping costs and other charges that may
        apply to this order. You can see the payment and delivery terms below.
      </li>
      <li>
        2-4 “Confirmation” is a stage that outlines the final details of your order. After this, we will send you
        a confirmation email detailing the products you have ordered.
        Please note that this email is not for order confirmation or acceptance
        order.
      </li>
      <li>
        3.4 After accepting your order, the contract between you and the service provider is finalized after accepting the order
        by delivering what you have ordered to you, if you have paid for the purchase of the Products using your card
        (not currently available) or when the Products are delivered to your address and provided that the Service Provider has received
        the full purchase price, unless we notify you that your order has been rejected or unless you cancel your order
        you have not canceled the order (please refer to the Returns section below).
      </li>
      <li>
        4.4 We retain your order and display it on your account for future review in the app.
        However, we reserve the right to dispose of old, closed orders if necessary
        for reasons beyond our control, so we recommend that you print and keep your order for reference
        for future reference.
      </li>
      <li>
        5-4 قد تكون هناك أخطاء في الأسعار التي تظهر على تطبيق خدمة في أي بي أو
        أثناء عملية إجراء الطلب من وقت لآخر. قد يكون هناك أيضا أخطاء في الإرسال
        قد تؤدي إلى انقطاع لعملية الشراء. سوف تبذل شركة ديجيتال يونيفرس أقصى
        جهدها لمحاولة حل أية مشاكل قد تنشأ نتيجة لمثل هذه الأخطاء.ويأتى دورك
        بالموافقة على التعاون مع الشركة في حل مثل هذه الأمور، وأنت توافق على أن
        تكون للشركة الحرية الكاملة للتصرف ولتحديد القرار المناسب في مثل هذه
        الحالات.
      </li>
      <li>
        6.4 Parties other than Digital Universe advertise and provide services (referred to as
        service providers) or sell their products through our App and such
        purchases from third parties will be restricted at the time of ordering and will be subject to these Terms
        as well as any other terms and conditions that may be dictated by that third party making the
        sale. Although Digital Universe makes every effort to ensure the quality of
        services provided by service providers, we do not guarantee the quality of any such
        offerings and products, and your purchase from any of these parties or individuals
        parties or individuals is at your own risk and expense.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* 5. Payment process:</h3>
      <li>
        5.1 Payment is made by one of the methods available in the Order and the payment method is selected
        by the user during order creation.
      </li>
      <li>5.2 The payment methods now available are (Cash on Delivery).</li>
      <li>
        5.3 The price you pay upon receipt of your order is the price displayed on the App. at
        at the time your order is received. Except for some exceptions.
      </li>
      <li>
        5.4 All prices mentioned on the app are the responsibility of the service provider or store
        Digital Universe is not responsible for them.
      </li>
      <li>
        5.5 If the Service Provider is unable to communicate with you if required, the Service Provider may
        cancel the order.
      </li>
      <li>
        5.6 Risk of loss, damage or ownership of the Products. shall pass to you as soon as you receive
        Products and payment in full at the address stated in the Order.
      </li>
      <li>
        5-7 All prices quoted are in Egyptian Pounds and include taxes and delivery charges
        if any.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>6, liability and indemnification:</h3>
      <li>
        1.6 Digital Universe does not warrant that the Application or any of the services or products
        available through it will be uninterrupted or error-free. There may be delays, omissions, interruptions, and/or inaccuracies in the materials or services available through the App.
        deletions, interruptions, and/or inaccuracies in the materials or services available through the
        the App.
      </li>
      <li>
        2.6 Although Digital Universe takes reasonable steps to prevent the introduction of
        viruses and other code on the Application, Digital Universe does not represent or warrant that the Services, Products and Materials
        does not represent or warrant that the Services, products or materials are free of such
        destructive agents. We are not responsible for any damages arising directly or indirectly
        directly or indirectly caused by these factors.
      </li>
      <li>
        3.6 In no event shall Digital Universe be held liable by you
        or any third party for any direct, indirect, special or consequential losses, damages
        of any kind (including, for example, loss of profits or business interruption.
        loss of programs or other data on your information system), even if
        Digital Universe has been informed
      </li>
      <li>
        4.6 Notwithstanding anything to the contrary, the total liability of
        Digital Universe (whether in tort, contractual or otherwise) for
        any and all losses or damages that you may incur as a result of your use of the Website.
        limited to an amount equal to the amount paid or payable by you for the product or products
        Products in the context of a single incident or series of incidents attributable to the same cause.
      </li>
      <li>
        5.6 We will take all reasonable precautions to keep your order and payment details
        secure, but unless we are negligent, we cannot be liable for any losses
        as a result of unauthorized access to the information you have provided. So, you are responsible for
        Maintaining the confidentiality of your account and password.
      </li>
      <li>
        6.6 Digital Universe reserves the right to refuse service, terminate accounts or
        remove or edit content, or cancel orders in its sole discretion.
      </li>
      <li>
        7.6 By using the App, you agree, to the extent permitted by law, to indemnify
        Digital Universe, its directors, officers, employees, affiliates, subsidiaries.
        its agents, contractors, contractors, agents, and licensors and hold them harmless with respect to
        any claims arising from your breach of these Terms, your use of the App or Products
        your violation of the law applicable to the place where you access the App, or any
        any action taken by Digital Universe as part of its investigation of a suspected
        breach of this Agreement or as a result of its conclusion or determination that a breach has occurred
        of this Agreement.
      </li>
    </ul>
  </div>
  <div class="menu-item-details">
    <ul>
      <h3>* 7, retrieval:</h3>
      <li>
        1.7 We are committed to contracting with quality service providers and we hope you
        you enjoy them. However, we also know that for one reason or another, there may be
        a time when you may need to exchange or return something you have purchased.
      </li>
      <li>
        2-7 Please be sure to carefully inspect your product upon delivery before
        use or before installation.
      </li>
      <li>
        3.7 We also recommend that you keep the delivery receipt and a copy of your order, which you can
        access them from your profile in the app, as proof of purchase in case of
        in case of any after-sales queries. Purchased products may be
        be returned or exchanged as per the service provider's own policy.
      </li>
      <li>
        4.7 All product sizes and measurements are approximate, but service providers are urged to
        ensure they are as accurate as possible. In some cases, the manufacturer's
        product specifications from the manufacturer may have changed or there may be an issue with the availability of some
        in which case an alternative of the same or better quality may be available at the same
        price. If you are not satisfied with the replacement or substitute, you can return these products
        according to the terms stated by the service provider.
      </li>
      <li>
        5.7 If the products to be returned or replaced are defective, do not conform to
        to the specifications in force in the Arab Republic of Egypt, or if the existing defect
        cannot be repaired without affecting the quality of these products. If the quality of these
        Products will not be jeopardized, the Service Provider has the right to refuse to replace or
        return these Products.
      </li>
      <li>
        6.7 Products may be replaced or returned if they are not genuine or counterfeit. And
        contact us in case the return is rejected by the service provider.
      </li>
      <li>
        7.7 The Service Provider reserves the right not to replace or return specific products such as watches
        foodstuffs, underwear, etc. that come into contact with
        skin except in the case of manufacturing defects or non-compliance with specifications or standards
        stipulated or if the product sold is different from the product you paid for.
        for which you paid. In such cases, the Service Provider may provide replacement products
        unless otherwise agreed with you. A complaint to Digital Universe if the
        Terms are not enforced by the Service Provider.
      </li>
      <li>
        8.7 You can exchange or return products if they meet the above conditions
      </li>
      <li>
        9.7 You can contact the service provider directly to schedule a return of the product
      </li>
      <li>
        10.7 Please note that refunds will be made using the same payment method you
        you used during purchase or you have the option to accept gift certificates or exchange
        the product for the same amount you paid as per your agreement with the service provider.
      </li>
    </ul>
  </div>

  <div class="menu-item-details">
    <ul>
      <h3>* 8. delivery service:</h3>
      <li>
        1.8 The user is responsible for providing the correct telephone numbers (landline and mobile)
        and the correct delivery address.
      </li>
      <li>
        2.8 If the order requires delivery and installation, the delivery and installation charges shall be determined
        through the service provider.
      </li>
      <li>
        3.8 If the Customer is not present, the items will be delivered to any other person present at the Customer's
        the Customer's address to pick up the items and sign the delivery order, and the Customer will be deemed to have
        the Customer has received the Product.
      </li>
      <li>
        4.8 Digital Universe will urge Service Providers to use their best efforts to deliver
        on time, and assumes no liability for any delay in delivery from the Service Provider
        service provider.
      </li>
      <li>
        5.8 Delivery charges are non-refundable from the service provider in case of
        wrong delivery information or if the customer cannot be reached via the phone number.
      </li>
      <li>
        6.8 Please make sure to give the correct delivery address when printing the invoice as this will enable
        This will enable the service provider to deliver quickly and in a timely manner to you and other
        customers.
      </li>
      <li>
        7-8 Please provide the following information:
        <ul>
          <li>Governor :</li>
          <li>Center :</li>
          <li>City :</li>
          <li>Part number:</li>
          <li>Street number :</li>
          <li>Building number :</li>
          <li>Recipient's name :</li>
          <li>Recipient's phone number:</li>
        </ul>
      </li>
      <li>
        8.8 If there is a change in the delivery address after the invoice has been issued, you can
        contact the service provider to review and correct the address.
      </li>
      <li>9.8 We would like you to be aware of the status and delivery time of your order from the Service Provider.</li>
    </ul>
  </div>

  <div class="menu-item-details">
    <ul>
      <h3>* 9. Miscellaneous provisions:</h3>
      <li>
        1.9 The contract between you and Digital Universe shall be governed by the laws of the Arab Republic of Egypt.
        without regard to conflict of laws rules and any dispute between you and Digital Universe
        Universe shall be heard exclusively in the courts of the Arab Republic of Egypt.
      </li>
      <li>
        2.9 Digital Universe shall not be liable for any delay or failure to deliver
        Products or otherwise the performance of any obligation as defined in these Terms if
        caused in whole or in part by force majeure events and/or due to force majeure.
        whether directly or indirectly, due to circumstances beyond its reasonable control.
        For the avoidance of doubt, force majeure events shall mean and include without limitation events of war.
        riots, civil war, insurrection, rebellion, earthquakes, hurricanes, tornadoes, floods or
        other physical natural disasters and/or acts of nature.
      </li>
      <li>
        3.9 Any links or references to other websites (“Hyperlinks”) contained in 5dma.vip by Digital Universe are for convenience only.
        Hyperlinks") contained on 5dma.vip by Digital Universe are provided solely as a convenience
        users of 5dma.vip, and Digital Universe is not responsible for the content or operation of any
        of these linked sites. In no event should any
        hyperlinks to such web sites should not be construed as an endorsement by Digital Universe
        Digital Universe or an advertisement or endorsement with respect to the content, statements, accuracy, products, services or content.
        products, services or content. The use of those hyperlinks
        (hyperlinks) are done at your own risk and cost.
      </li>
      <li>
        4.9 Digital Universe reserves the right to transfer, assign or subcontract all or part of
        or part of any of its rights or obligations under these Terms or any other relevant contract
        to any third party.
      </li>
      <li>
        5.9 If any part of these Terms is held by any competent authority to be invalid or unenforceable
        or unenforceable in whole or in part, this shall not affect the validity or enforceability of
        other conditions.
      </li>
      <li>
        6.9 These Terms do not create or confer any rights or benefits enforceable by any
        person who is not a party to them.
      </li>
      <li>
        7.9 Any delay or failure by Digital Universe to exercise any powers, rights, or
        remedies under these Terms shall not constitute a waiver by Digital Universe of them, and
        any exercise of part of such rights and powers shall not preclude the exercise of other rights or remedies
        other rights or remedies or the exercise of further rights or remedies. To be effective, any waiver must be
        in writing and signed by an authorized representative of Digital Universe.
      </li>
      <li>
        8.9 These Terms, including the documents or other sources referred to in
        these Terms supersede all prior representations, understandings and agreements between you
        and Digital Universe relating to the use of 5dma.vip or the App (including
        use of the Services and/or ordering Products) and sets forth the entire agreement and understanding between you
        and Digital Universe regarding the particular use of the App and 5dma.vip.
      </li>

      <li>
        9.9 When you visit 5dma.vip or send emails to us, you are
        communicating with us electronically. You agree to receive communications from us
        electronically. We will communicate with you by email or telephone.
      </li>
      <li>
        9.10 You agree that all agreements, notices, statements, and other communications that we provide to you
        electronically satisfy any legal requirement that communications must be in writing.
      </li>
    </ul>
  </div>
  <div
    class="menu-item-details"
    style="color: gray; font-weight: bold; margin-top: 100px"
  >
    <ul>
      <li>
        Digital Universe Information Technology Co. L.L.C. L.L.C. Mit Ghamr - Dakahlia - Egypt
      </li>
      <li>Arab Republic of Egypt</li>
      <li>Registered in the Arab Republic of Egypt - No. 9226</li>
      <li>E-mail : Info&#64;du-apps.com</li>
      <li>Website : www.du-apps.com</li>
      <li>
        We recommend printing a copy of these terms for future reference. If you have any questions regarding this
        website 5dma.vip or the App, please refer to the Contact Us section for more information and full contact
        details.
      </li>
    </ul>
  </div>
</div>


<!--<div *ngIf="false">-->
<!--  <p class="title">-->
<!--    <strong>Alshaya Privileges Club</strong> Terms and Conditions-->
<!--  </p>-->
<!--  <ol>-->
<!--    <li>-->
<!--      By downloading or using the Privileges Club Mobile App-->
<!--      (&lsquo;App&rsquo;), these terms will automatically apply. In addition, by-->
<!--      accepting these Terms &amp; Conditions, you will receive notifications-->
<!--      from Privileges Club; to opt out of promotional communications please-->
<!--      visit the My Preferences section of the App. We are offering you this app-->
<!--      to use for your own personal use without cost, but you should be aware-->
<!--      that you cannot send it on to anyone else, and you&rsquo;re not allowed to-->
<!--      copy, or modify the app, any part of the app, or our trademarks in any-->
<!--      way. You&rsquo;re not allowed to attempt to extract the source code of the-->
<!--      app. The app itself, and all the trade marks, copyright, database rights-->
<!--      and other intellectual property rights related to it, still belong to M.H.-->
<!--      Alshaya Co. W.L.L. (&lsquo;Alshaya&rsquo;).-->
<!--    </li>-->
<!--    <li>-->
<!--      Only individuals thirteen (13) years of age or older may use the-->
<!--      App.&nbsp; Users between the ages of thirteen (13) and eighteen (18) must-->
<!--      review these Terms with a parent or legal guardian to ensure the parent or-->
<!--      legal guardian acknowledge and agree to these Terms.&nbsp; Should-->
<!--      User&rsquo;s parent or legal guardian not acknowledge and agree to these-->
<!--      Terms, User must immediately uninstall this Application and discontinue-->
<!--      its use.-->
<!--    </li>-->
<!--    <li>-->
<!--      Employees of Alshaya are automatically excluded from the public prize-->
<!--      draws.&nbsp; In accordance with Ministry requirements, first and second-->
<!--      degree family members of employees of Alshaya, along with anyone else-->
<!--      connected with the prize draw, are not eligible for the prizes and must-->
<!--      inform Alshaya if selected as a winner so that the relevant prize may be-->
<!--      re-allocated.-->
<!--    </li>-->
<!--    <li>-->
<!--      App features, such as the Privileges Club digital card, store locator,-->
<!--      Prize Draw information, feedback, account management, and interaction with-->
<!--      social media sites, may use, maintain, or transmit User&rsquo;s personal-->
<!--      information, including, user names, passwords, proper names, email-->
<!--      address, address, location, Digital card information, GPS location-->
<!--      information, information for and from third-party and social-media-->
<!--      accounts (collectively &ldquo;User Information&rdquo;).&nbsp; By-->
<!--      acknowledging and agreeing to these Terms and Conditions, or by using the-->
<!--      App, User consents to the transmission of User Information to Alshaya,-->
<!--      including its agents and third-party partners, and consents to Alshaya,-->
<!--      including its agents and third-party partners, receiving, collecting,-->
<!--      storing, processing, transmitting, and using User Information for App-->
<!--      functionality and for the purposes disclosed in the Alshaya&rsquo;s-->
<!--      privacy policy.-->
<!--    </li>-->
<!--    <li>-->
<!--      The User is, however, solely responsible for the confidentiality and-->
<!--      security of User Information sent from or stored on the mobile / portable-->
<!--      device(s) by the App.The User is also solely responsible for all-->
<!--      transactions and activities undertaken by anyone with any Digital Card-->
<!--      registered in the User&rsquo;s name, whether authorized or unauthorized.-->
<!--      This includes any and all unauthorized purchases made from the-->
<!--      Alshaya&rsquo;s participating Brands and outlets (Alshaya store or-->
<!--      restaurant displaying the Privileges Club logo).-->
<!--    </li>-->
<!--    <li>-->
<!--      The User agrees to immediately notify Alshaya of any suspected-->
<!--      unauthorized transactions associated with the App or any other breach of-->
<!--      security.&nbsp; Alshaya shall not be responsible for any losses arising-->
<!--      from the financial loss or theft of User Information due to unauthorized-->
<!--      or fraudulent transactions related to the App.&nbsp; Users shall be solely-->
<!--      responsible for taking precautionary steps to protect User Information-->
<!--      stored on the Device, including without limitation password-protecting the-->
<!--      Device.-->
<!--    </li>-->
<!--    <li>-->
<!--      Alshaya reserves the right to make changes to the app or to charge for its-->
<!--      services, at any time and for any reason and at its sole discretion by-->
<!--      posting revisions on the App. Continued use of the App following the-->
<!--      posting of these changes or modifications will constitute acceptance of-->
<!--      such changes or modifications.-->
<!--    </li>-->
<!--    <li>-->
<!--      Certain functions of the app will require the app to have an active-->
<!--      internet connection. The connection can be Wi-Fi, or provided by your-->
<!--      mobile / portable device(s) network provider. Alshaya cannot take-->
<!--      responsibility for the app not working at full functionality if you-->
<!--      don&rsquo;t have access to Wi-Fi, and you don&rsquo;t have any of your-->
<!--      data allowance left.-->
<!--    </li>-->
<!--    <li>-->
<!--      If you&rsquo;re using the app outside of an area with Wi-Fi, you should-->
<!--      remember that your terms of agreement with your mobile network provider-->
<!--      will still apply. As a result, you may be charged by your mobile services-->
<!--      provider for the cost of data for the duration of the connection while-->
<!--      accessing the app. In using the app, you&rsquo;re accepting responsibility-->
<!--      for any such charges, including roaming data charges if you use the app-->
<!--      outside of your home territory (i.e. region or country) without turning-->
<!--      off data roaming. If you are not the bill payer for the device on which-->
<!--      you&rsquo;re using the app, please be aware that we assume that you have-->
<!--      received permission from the bill payer for using the app.-->
<!--    </li>-->
<!--    <li>-->
<!--      It&rsquo;s possible from time to time that Alshaya staff may need to-->
<!--      briefly handle your device when your Digital Card or Discount coupon is-->
<!--      scanned at the point of sale. While our staff will of course take all-->
<!--      reasonable care to make sure nothing happens to your device, we-->
<!--      don&rsquo;t accept liability for damage to it, unless it&rsquo;s caused by-->
<!--      any negligence or willful misconduct by our staff. You also need to make-->
<!--      sure that your device stays charged.-->
<!--    </li>-->
<!--    <li>-->
<!--      At some point we may wish to update the app. The app is currently-->
<!--      available on Android and iOS &ndash; the requirements for both systems-->
<!--      (and for any additional systems we decide to extend the availability of-->
<!--      the app to) may change, and you&rsquo;ll need to download the updates if-->
<!--      you want to keep using the app. Alshaya does not promise that it will-->
<!--      always update the app so that it is relevant to you and/or works with the-->
<!--      iOS/Android version that you have installed on your device. However, you-->
<!--      promise to always accept updates to the application when offered to you,-->
<!--      We may also wish to stop providing the app, and may terminate use of it at-->
<!--      any time without giving prior notice of termination to you. Unless we tell-->
<!--      you otherwise, upon any termination, (a) the rights and licenses granted-->
<!--      to you in these terms will end; (b) you must stop using the app, and (if-->
<!--      needed) delete it from your device.-->
<!--    </li>-->
<!--    <li>-->
<!--      Prohibited Uses: Use of the App is limited to the contemplated-->
<!--      functionality.&nbsp; The App shall not be used in any way that- -->
<!--      <ul>-->
<!--        <li>-->
<!--          Harasses, abuses, stalks, threatens, defames, or otherwise infringes-->
<!--          or violates the rights of any other party (including but not limited-->
<!--          to rights of publicity or other proprietary rights);-->
<!--        </li>-->
<!--        <li>Is unlawful, fraudulent, or deceptive;</li>-->
<!--        <li>-->
<!--          Uses technology or other means to access unauthorized content or-->
<!--          non-public spaces;-->
<!--        </li>-->
<!--        <li>-->
<!--          Uses or launches any automated system or process, including without-->
<!--          limitation, &ldquo;bots,&rdquo; &ldquo;spiders,&rdquo; or-->
<!--          &ldquo;crawlers,&rdquo; to access unauthorized content or non-public-->
<!--          spaces;-->
<!--        </li>-->
<!--        <li>-->
<!--          Attempts to introduce viruses or any other harmful computer code,-->
<!--          files or programs that interrupt, destroy or limit the functionality-->
<!--          of any computer software or hardware or telecommunications equipment;-->
<!--        </li>-->
<!--        <li>-->
<!--          Attempts to damage, disable, overburden, or impair Alshaya Brands-->
<!--          servers or networks;-->
<!--        </li>-->
<!--        <li>-->
<!--          Attempts to gain unauthorized access to a Alshaya&rsquo;s Brands-->
<!--          computer network;-->
<!--        </li>-->
<!--        <li>-->
<!--          Attempts to gain unauthorized access to Alshaya&rsquo;s Brands&rsquo;-->
<!--          user accounts;-->
<!--        </li>-->
<!--        <li>-->
<!--          Encourages conduct that would constitute a criminal offense, or that-->
<!--          gives rise to civil liability;-->
<!--        </li>-->
<!--        <li>Violates these Terms in any manner; or</li>-->
<!--        <li>-->
<!--          Fails to comply with applicable third-party terms and conditions or-->
<!--          other third-party policies (collectively &ldquo;Acceptable-->
<!--          Use&rdquo;).-->
<!--        </li>-->
<!--      </ul>-->
<!--    </li>-->
<!--    <li>-->
<!--      Alshaya reserves the right, in its sole discretion, to  any User-->
<!--      License, remove Content, assist law enforcement in the prosecution of-->
<!--      criminal liability, or assert a civil or criminal legal action with-->
<!--      respect to Content or use of the App, including any Privileges Club-->
<!--      Digital Card, that Alshaya reasonably believes is or might be in violation-->
<!--      of these Terms, but failure or delay in taking such actions or any part-->
<!--      thereof does not constitute a waiver of its rights to enforce these Terms.-->
<!--    </li>-->
<!--    <li>-->
<!--      The User may generate content, written or otherwise, while using the App-->
<!--      (&ldquo;User-Generated Content&rdquo;).&nbsp; User acknowledges and agrees-->
<!--      that User-Generated Content may be used, reproduced, displayed, modified,-->
<!--      deleted, added too, adapted, and published by Alshaya (for example, in-->
<!--      product marketing campaigns).&nbsp; User grants Alshaya a worldwide;-->
<!--      irrevocable; transferrable; sub licensable; fully-paid and royalty-free;-->
<!--      and non-exclusive license to use, reproduce, display, modify, delete from,-->
<!--      add to, adapt, publish, and prepare derivative works from the-->
<!--      User-Generated Information.&nbsp; User further acknowledges and agrees-->
<!--      that the User, and the User alone, is responsible for the development of-->
<!--      User-Generated Content.-->
<!--    </li>-->
<!--    <li>-->
<!--      These Terms supplement and incorporate (a) the Apple, Inc.-->
<!--      (&ldquo;Apple&rdquo;) Terms and Conditions (located at-->
<!--      <a-->
<!--        href="http://www.apple.com/legal/internet-services/itunes/us/terms.html"-->
<!--        >http://www.apple.com/legal/internet-services/itunes/us/terms.html</a-->
<!--      >) including, without limitation, the Licensed Application End User-->
<!--      License Agreement provided therein (&ldquo;Apple Terms&rdquo;).&nbsp; If-->
<!--      any of the provisions of the Apple Terms and Conditions conflict with-->
<!--      these Terms, these Terms will control, solely to the extent such terms-->
<!--      apply to the App.-->
<!--    </li>-->
<!--    <li>-->
<!--      This document is in the Arabic and English languages. If there is any-->
<!--      discrepancy between the Arabic and the English texts, the Arabic text-->
<!--      prevails.-->
<!--    </li>-->
<!--    <li>-->
<!--      These Terms are governed by the laws of the state of the relevant-->
<!--      territory.&nbsp; The User irrevocably consents to the exclusive-->
<!--      jurisdiction of the relevant territory&rsquo;s courts for purposes of any-->
<!--      legal action arising out of or related to the use of the App or these-->
<!--      Terms.-->
<!--    </li>-->
<!--  </ol>-->
<!--</div>-->
